

import React from "react";
import { Dialog, DialogContent, Slide, SlideProps } from "@mui/material";
import { Button as ButtonAntd } from "antd";
import { CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import { getImageBlob, removeImageBlob } from "../../../helpers";


interface VideoPlayerModalProps {
  videoKey: string;
  open: boolean;
  onClose: () => void;
  onClear: () => void;
}

const Transition = React.forwardRef<HTMLDivElement, SlideProps>(
  function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  }
);

export const VideoPlayerModal: React.FC<VideoPlayerModalProps> = ({
  videoKey,
  open,
  onClose,
  onClear,
}) => {
  const [videoUrl, setVideoUrl] = React.useState("");

  React.useEffect(() => {
    let objectUrl = "";
    if (!videoKey) {
      setVideoUrl("");
      return;
    }

    // Verificar si videoKey es una URL que comienza con "http"
    if (videoKey.startsWith("http://") || videoKey.startsWith("https://")) {
      setVideoUrl(videoKey); // Usar la URL directamente
    } else {
      // Si no es una URL, asumir que es un key para obtener el blob
      (async () => {
        const blob = await getImageBlob(videoKey);
        if (blob) {
          objectUrl = URL.createObjectURL(blob);
          setVideoUrl(objectUrl);
        }
      })();
    }

    // Cleanup para revocar la URL de objeto si fue creada
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [videoKey]);

  const handleClearVideo = async () => {
    // Solo intentar eliminar el blob si videoKey no es una URL
    if (!videoKey.startsWith("http://") && !videoKey.startsWith("https://")) {
      await removeImageBlob(videoKey);
    }
    onClear();
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <DialogContent style={{ position: "relative", padding: 0 }}>
        <>
          <ButtonAntd
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              zIndex: 1601,
            }}
            size="large"
            onClick={onClose}
            type="primary"
            danger
            shape="circle"
            icon={<CloseCircleOutlined />}
          />
          <ButtonAntd
            style={{
              position: "absolute",
              top: 10,
              right: 70,
              zIndex: 1601,
            }}
            size="large"
            onClick={handleClearVideo}
            type="primary"
            shape="circle"
            icon={<ReloadOutlined />}
          />
          <video controls style={{ width: "100%", height: "100vh" }}>
            <source type="video/webm" src={videoUrl} />
          </video>
        </>
      </DialogContent>
    </Dialog>
  );
};

